/**
 * /frontend/src/features/analytics/components/charts/FunnelChart.js
 */

import React from 'react';
import {
  Bar,
  BarChart,
  CartesianGrid,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis
} from 'recharts';
import { CHART_CONFIG } from '../../constants/chartConfig';
import { CHART_COLORS } from '../../constants/chartColors';

/**
 * Simple funnel chart (staged horizontal bars).
 * @param {{data:Array<{stage:string,count:number}>,height?:number}} props
 * @returns {JSX.Element}
 */
const FunnelChart = ({ data, height }) => {
  const safeData = Array.isArray(data) ? data : [];
  if (!safeData.length) {
    return <div className="analytics-chart-empty-inline">No data available for the selected range.</div>;
  }

  return (
    <ResponsiveContainer width="100%" height={height || CHART_CONFIG.height}>
      <BarChart data={safeData} layout="vertical" margin={CHART_CONFIG.margin}>
        <CartesianGrid stroke={CHART_CONFIG.gridStroke} strokeDasharray="4 6" />
        <XAxis type="number" stroke={CHART_CONFIG.axisStroke} tick={{ fill: CHART_CONFIG.tickFill, fontSize: 12 }} />
        <YAxis type="category" dataKey="stage" stroke={CHART_CONFIG.axisStroke} tick={{ fill: CHART_CONFIG.tickFill, fontSize: 12 }} width={120} />
        <Tooltip />
        <Bar dataKey="count" fill={CHART_COLORS.accent} radius={[0, 10, 10, 0]} />
      </BarChart>
    </ResponsiveContainer>
  );
};

export default FunnelChart;
